import React from 'react';
import { EmployeeWithAvatar } from '../../../components/Employee';
import { TimeSheetEmployee } from '../../../components/TimeSheetsTable';

type Props = {
  employee: TimeSheetEmployee;
};

export const EmployeeCell: React.FC<React.PropsWithChildren<Props>> = ({
  employee,
}) => {
  return (
    <EmployeeWithAvatar
      dataTestId="employee-cell"
      employee={{
        name: employee.name,
        avatarUrl: employee.avatarUrl,
      }}></EmployeeWithAvatar>
  );
};
